import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Unwatch.svg?component
var Unwatch_exports = /* @__PURE__ */ __exportAll({
	default: () => Unwatch_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M4.9 19.1c-3.038-3.038-3.71-7.592-2.015-11.3M7.8 16.2c-1.397-1.397-1.945-3.346-1.646-5.2M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5m2.9-11.4C23 8.8 23 15.1 19.1 19m-8.423-8.5a2 2 0 0 1 2.75 2.901M22 22 2 2"
	}, null, -1)])]);
}
var Unwatch_default = { render: render$1 };
//#endregion
export { Unwatch_exports, Unwatch_default as default, render$1 as render };

//# sourceMappingURL=Unwatch.svg.virtual.js.map